// Default S/4HANA Executive Dashboard data.
// Stored under doc.s4hana — any edits persist via mutate().
export const S4_DEFAULTS = {
  programName: "S/4HANA Global Transformation Program",
  programTagline: "Senior Director — Program Execution · Reporting to CIO",
  period: "Q2 2026 · Updated May 23",
  scope: "Global S/4HANA Transformation · 18 Countries",

  // 6 top KPI strip cards
  summary: [
    { label: "Program Completion", value: "64%",  trend: "▲ +3% MoM",       tone: "green"  },
    { label: "Budget Adherence",   value: "97%",  trend: "On track",        tone: "green"  },
    { label: "Clean Core %",       value: "78%",  trend: "Target 85%",      tone: "amber"  },
    { label: "Milestones On-Time", value: "71%",  trend: "3 at risk",       tone: "amber"  },
    { label: "Open Risks",         value: "14",   trend: "▲ 2 new",         tone: "red"    },
    { label: "Go-Live Readiness",  value: "68%",  trend: "↑ Improving",     tone: "green"  },
  ],

  // Tab 1 — Program Health
  workstreams: [
    { name: "Finance (FI/CO)",        pct: 82 },
    { name: "Order-to-Cash",          pct: 75 },
    { name: "Procure-to-Pay",         pct: 68 },
    { name: "Supply Chain / MM",      pct: 60 },
    { name: "Manufacturing / PP",     pct: 55 },
    { name: "Data Migration",         pct: 48 },
    { name: "Integrations",           pct: 52 },
    { name: "Analytics / BW4HANA",    pct: 44 },
    { name: "Security / Auth.",       pct: 70 },
    { name: "Cutover Planning",       pct: 31 },
  ],
  phaseData: [
    { phase: "Explore", done: 100 },
    { phase: "Design",  done: 100 },
    { phase: "Build",   done: 72 },
    { phase: "Test",    done: 38 },
    { phase: "Deploy",  done: 0 },
  ],
  designMetrics: [
    { label: "Design Sign-offs",  value: "89%", sub: "Of BBPs approved", tone: "green" },
    { label: "Fit-to-Standard %", value: "73%", sub: "Target 80%",       tone: "amber" },
    { label: "Scope Deviations",  value: "12",  sub: "Pending review",   tone: "red"   },
  ],
  techMetrics: [
    { label: "Clean Core %",      value: "78%", sub: "Target 85%",   tone: "amber" },
    { label: "Tech Debt Index",   value: "Med", sub: "7 deviations", tone: "amber" },
    { label: "Custom Objects",    value: "34",  sub: "↑ Creeping",    tone: "red"   },
    { label: "Integration Points",value: "62",  sub: "41% tested",   tone: "amber" },
  ],

  // Tab 2 — Value Realization
  valueKpis: [
    { label: "DSO Reduction",     value: "−3.2d", sub: "Target −8 days",   tone: "blue"  },
    { label: "Inventory Turn ↑",  value: "+12%",  sub: "On track",         tone: "green" },
    { label: "Working Capital",   value: "$18M",  sub: "Projected release",tone: "green" },
    { label: "EBITDA Impact (3yr)",value: "$42M", sub: "$13.6M realized",  tone: "blue"  },
  ],
  benefits: [
    { area: "Finance",      target: 12, realized: 4.2 },
    { area: "Procurement",  target: 8,  realized: 3.2 },
    { area: "Supply Chain", target: 10, realized: 2.1 },
    { area: "Revenue Ops",  target: 7,  realized: 1.4 },
    { area: "IT Cost",      target: 5,  realized: 2.8 },
  ],
  valueTracker: [
    { area: "Order Cycle Time",     target: "−20%",   actual: "−11%",  status: "In Prog"  },
    { area: "Invoice Processing",   target: "−30%",   actual: "−28%",  status: "On Track" },
    { area: "PO Automation",        target: "75%",    actual: "62%",   status: "In Prog"  },
    { area: "Month-End Close",      target: "−2 days",actual: "−1.5d", status: "On Track" },
    { area: "Warehouse Efficiency", target: "+18%",   actual: "+6%",   status: "At Risk"  },
    { area: "Procurement Savings",  target: "$8M",    actual: "$3.2M", status: "In Prog"  },
    { area: "Report Automation",    target: "60%",    actual: "22%",   status: "At Risk"  },
    { area: "Intercompany Recon",   target: "−3 days",actual: "−1 day",status: "In Prog"  },
    { area: "Vendor Payment Terms", target: "+Net 10",actual: "+Net 5",status: "On Track" },
  ],

  // Tab 3 — Governance
  govKpis: [
    { label: "Workshops Led QTD",   value: "24",    sub: "8 exec-level", tone: "blue"  },
    { label: "Decisions Made",      value: "61",    sub: "Avg 2.1 days", tone: "green" },
    { label: "Escalations Resolved",value: "18/21", sub: "86% closure",  tone: "green" },
    { label: "Process Harmonized",  value: "67%",   sub: "Target 80%",   tone: "amber" },
  ],
  governance: [
    { ind: "Steering Comm Engagement", score: "4.2/5", status: "Strong" },
    { ind: "Design Authority Velocity",score: "4.0/5", status: "Stable" },
    { ind: "Scope Control",            score: "3.5/5", status: "Watch"  },
    { ind: "Template Governance",      score: "3.8/5", status: "Stable" },
    { ind: "SI Partner Alignment",     score: "3.3/5", status: "At Risk"},
    { ind: "Business Engagement",      score: "4.1/5", status: "Strong" },
    { ind: "CIO Alignment",            score: "4.5/5", status: "Strong" },
    { ind: "Clean Core Governance",    score: "3.6/5", status: "Watch"  },
  ],
  templateMetrics: [
    { label: "Entities Live",     value: "0/18" },
    { label: "Template Frozen",   value: "4/12" },
    { label: "Countries Scoped",  value: "18"   },
  ],
  decisionTrend: [
    { m: "Jan", d: 9.1 },
    { m: "Feb", d: 7.8 },
    { m: "Mar", d: 6.5 },
    { m: "Apr", d: 5.9 },
    { m: "May", d: 6.4 },
  ],
  pendingDecisions: [
    { ws: "Supply Chain", count: "4 open", pct: 57, tone: "red"   },
    { ws: "Finance / CO", count: "2 open", pct: 29, tone: "amber" },
    { ws: "Integrations", count: "1 open", pct: 14, tone: "blue"  },
    { ws: "Analytics",    count: "0 open", pct: 0,  tone: "blue"  },
  ],

  // Tab 4 — Risk & Issues
  riskKpis: [
    { label: "Total Open Risks",   value: "14",  sub: "3 Critical",      tone: "red"   },
    { label: "Open Issues",        value: "31",  sub: "8 Escalated",     tone: "amber" },
    { label: "Risks Mitigated QTD",value: "9",   sub: "↑ Good pace",     tone: "green" },
    { label: "Avg Resolution Days",value: "6.4", sub: "Target <5 days",  tone: "amber" },
  ],
  riskBuckets: [
    { cat: "Data Migration",     critical: 1, high: 1, med: 1 },
    { cat: "Clean Core / Tech",  critical: 0, high: 2, med: 1 },
    { cat: "Scope & Change",     critical: 0, high: 2, med: 1 },
    { cat: "Resource / SI",      critical: 1, high: 1, med: 0 },
    { cat: "Business Readiness", critical: 0, high: 1, med: 1 },
    { cat: "Integration",        critical: 1, high: 1, med: 0 },
  ],
  topRisks: [
    { desc: "Data migration quality gaps",       severity: "Critical" },
    { desc: "Reporting / analytics gap",         severity: "Critical" },
    { desc: "SI resource attrition",             severity: "Critical" },
    { desc: "EWM integration complexity",        severity: "High"     },
    { desc: "Change resistance — NA region",     severity: "High"     },
    { desc: "Scope creep in OTC",                severity: "High"     },
    { desc: "Clean Core compliance drift",       severity: "High"     },
    { desc: "Hyper-care staffing readiness",     severity: "High"     },
  ],
  raidStats: [
    { label: "RAID Open Actions",   value: "47" },
    { label: "Decisions Pending",   value: "7"  },
    { label: "Assumptions Logged",  value: "23" },
    { label: "Dependencies Tracked",value: "38" },
  ],

  // Tab 5 — Change & Adoption
  changeKpis: [
    { label: "Training Completion",   value: "41%",   sub: "Target 100%",      tone: "amber" },
    { label: "Change Readiness Score",value: "3.6/5", sub: "Improving",        tone: "amber" },
    { label: "Super-Users Trained",   value: "68/120",sub: "57%",              tone: "blue"  },
    { label: "Comms Published",       value: "34",    sub: "On schedule",      tone: "green" },
  ],
  readiness: [
    { region: "North America", pct: 58, tone: "amber" },
    { region: "Europe",        pct: 72, tone: "green" },
    { region: "Asia Pacific",  pct: 65, tone: "blue"  },
    { region: "Latin America", pct: 44, tone: "amber" },
    { region: "Middle East",   pct: 38, tone: "red"   },
    { region: "Africa",        pct: 31, tone: "red"   },
  ],
  ocm: [
    { item: "Executive sponsorship secured",  status: "Complete"    },
    { item: "OCM strategy & roadmap",         status: "Complete"    },
    { item: "Stakeholder impact assessment",  status: "Complete"    },
    { item: "Role mapping & persona design",  status: "In Progress" },
    { item: "Training curriculum built",      status: "In Progress" },
    { item: "Resistance management plan",     status: "In Progress" },
    { item: "Cutover comms plan",             status: "Not Started" },
    { item: "Hyper-care staffing model",      status: "Not Started" },
  ],
  changeFooter: [
    { label: "Resistance Index",  value: "Medium", sub: "NA region highest", tone: "amber" },
    { label: "Cutover Readiness", value: "31%",    sub: "Needs focus",       tone: "red"   },
  ],

  // Tab 6 — Workshop Leadership
  workshopKpis: [
    { label: "Total Workshops QTD", value: "24",  sub: "↑ 4 vs last qtr",  tone: "blue"   },
    { label: "You Led (Exec)",      value: "8",   sub: "Senior Dir level", tone: "purple" },
    { label: "Decisions Driven",    value: "19",  sub: "From workshops",   tone: "green"  },
    { label: "Escalations Resolved",value: "7",   sub: "In-session",       tone: "green"  },
    { label: "Exec Attendance %",   value: "87%", sub: "Target 80%",       tone: "green"  },
  ],
  leadershipSplit: {
    youPct: 33, youCount: "8 of 24 workshops",
    delPct: 67, delCount: "16 of 24 workshops",
  },
  outcomes: [
    { o: "Decisions made",                  count: "19", trend: "↑ Strong",    tone: "green" },
    { o: "Escalations resolved in-session", count: "7",  trend: "↑ High value",tone: "green" },
    { o: "Customisations challenged",       count: "11", trend: "→ Active",    tone: "blue"  },
    { o: "Scope items removed / deferred",  count: "6",  trend: "↑ Good",      tone: "green" },
    { o: "Process harmonisation agreed",    count: "4",  trend: "→ Stable",    tone: "amber" },
    { o: "Stalemates broken",               count: "5",  trend: "↑ High value",tone: "green" },
    { o: "Actions delegated to Directors",  count: "28", trend: "Leveraged",   tone: "neutral"},
  ],
  catalog: [
    { name: "Executive Strategy & Transformation Roadmap", desc: "Enterprise vision alignment, 3-year roadmap, scalability across 18 countries, EBITDA linkage and programme resets", tags: ["Alignment","Roadmap","EBITDA"] },
    { name: "Global Design Authority Sessions",            desc: "Process deviation challenges, Clean Core governance, template freeze decisions, customisation ROI review",         tags: ["Clean Core","Template","Governance"] },
    { name: "Enterprise Process Harmonisation",            desc: "Cross-regional process standardisation, fit-to-standard adoption, SI over-engineering reset",                       tags: ["Harmonisation","Fit-to-Standard"] },
    { name: "Value Realization & Benefits Workshops",      desc: "DSO, inventory turns, working capital, cycle time — tying transformation outcomes to the business case",            tags: ["Value","KPIs","Business Case"] },
    { name: "Risk Mitigation & Executive Decision-Making", desc: "Stalled decisions, escalation resolution, scope control — requiring Senior Director executive presence",            tags: ["Escalation","Decisions","Risk"] },
  ],
  questions: [
    "Why are we customising this instead of adopting SAP standard?",
    "How does this impact global template governance?",
    "What is the downstream effect on Finance and Supply Chain?",
    "Will this scale across all 18 countries?",
    "What is the ROI of this process deviation?",
    "How does this improve cycle time, inventory turns, or DSO?",
    "Are we enabling Clean Core or creating technical debt?",
    "Does this align with our RISE / BTP clean core commitment?",
  ],
  interviewQuote:
    "Yes, absolutely. At the Senior Director level, I typically lead **strategic transformation workshops** focused on enterprise alignment, process harmonisation, governance, value realisation, and executive decision-making. My Directors and functional leads facilitate the detailed fit-gap and configuration workshops, while I focus on ensuring the transformation aligns with **business outcomes, scalable architecture, Clean Core principles, and long-term operational strategy**. On large or troubled programmes, I step directly into workshops when stakeholders are misaligned, decisions are stalled, or the SI partner is over-engineering solutions — because that is where **executive presence and transformation authority** become critical to programme momentum.",
};

// Cycle helpers for click-to-update badges
export const STATUS_CYCLES = {
  default:   ["On Track", "In Prog", "At Risk", "Stable", "Complete"],
  severity:  ["Critical", "High", "Medium", "Low"],
  ocm:       ["Complete", "In Progress", "Not Started", "On Hold"],
  governance:["Strong", "Stable", "Watch", "At Risk"],
};

export const TONE_TO_PILL = {
  green: "green", amber: "amber", red: "red", blue: "blue",
  purple: "purple", neutral: "neutral",
};

export const STATUS_TO_TONE = {
  "On Track":   "green",  "Strong":      "green", "Complete":   "green",
  "In Prog":    "amber",  "In Progress": "amber", "Watch":      "amber",
  "Stable":     "blue",   "On Hold":     "neutral",
  "At Risk":    "red",    "Not Started": "red",
  "Critical":   "red",    "High":        "amber", "Medium":     "blue",
  "Low":        "neutral",
};

export function nextStatus(current, cycle = "default") {
  const list = STATUS_CYCLES[cycle] || STATUS_CYCLES.default;
  const idx = list.indexOf(current);
  return list[(idx + 1) % list.length];
}
